import { useLocation } from 'react-router-dom';
import { forwardRef } from 'react';

// CONSTANTS
import menuItems from 'constants/menu';

const PageHeader = forwardRef((props, ref) => {
  const location = useLocation();
  const pathname = location.pathname;

  // Trier les éléments du menu par longueur de chemin
  const sortedMenuItems = [...menuItems].sort((a, b) => b.path.length - a.path.length);

  // Trouver l'élément actif
  const activeMenu = sortedMenuItems.find((item) => {
    if (item.children?.length) {
      return pathname.startsWith(item.path);
    }
    return pathname === item.path;
  });

  // Trouver sous-menu actif s'il y en a
  const activeSub = activeMenu?.children?.find((sub) => pathname === sub.path);
  const Icon = activeMenu?.icon;

  return (
    <div ref={ref} className="w-full px-6 py-2 flex items-center gap-4 text-noir dark:text-blanc">
      {Icon && <Icon size={24} />}
      <span className="text-h5">
        {activeMenu ? activeMenu.label : ''}
      </span>

      {activeSub && (
        <div className="flex items-center border-l pl-4">
          <span className="text-thin-s">{activeSub.label}</span>
        </div>
      )}
    </div>
  );
});

export default PageHeader;